<div
  fxLayout="column"
  [ngClass]="{
    'config-hidden':
      configMode && !config.isSimpleValue && !showEditor(resource.rightSets),
    'edit-mode':
      !config.isSimpleValue &&
      !creationMode &&
      config.attributeName &&
      !config.attributeName.endsWith('#')
  }"
  style="width: 100%"
>
  <div class="label-attribute-name-normal" style="margin-bottom: 10px">
    {{ displayName | translate }}
  </div>
  <div
    fxLayout="column"
    fxLayoutGap="10px grid"
    style="font-size: 0.75em; font-weight: 400; color: rgba(0, 0, 0, 0.54)"
  >
    <div *ngIf="control && control.invalid; else validated" class="warn-color">
      {{ control.errors['message'] | translate }}
    </div>
    <ng-template #validated>
      <div
        fxFlex="none"
        *ngIf="description"
        class="label-attribute-desc"
        [matTooltip]="description | translate"
      >
        {{ description | translate | ellipsis: config.hintLimit }}
      </div>
      <div
        fxFlex="none"
        *ngIf="
          !config.isSimpleValue &&
          !hideNoWriteAccessMessage &&
          readAccess &&
          !writeAccess
        "
        style="color: #d8bb2e"
      >
        <mat-icon
          [matTooltip]="'key_noWriteAccess' | translate"
          style="font-size: 14px"
          >error</mat-icon
        >
      </div>
      <div
        fxFlex="none"
        *ngIf="!config.isSimpleValue && !hideNoReadAccessMessage && !readAccess"
      >
        <mat-icon
          [matTooltip]="'key_noReadAccess' | translate"
          style="color: red; padding-top: 4px; font-size: 14px"
          >error</mat-icon
        >
      </div>
    </ng-template>
  </div>
  <div
    *ngIf="
      !config.isSimpleValue &&
        disabled(resource.rightSets) &&
        (!iterableValue || iterableValue.length === 0);
      else iterableFields
    "
    class="background-bg-color label-attribute-desc"
    style="margin-top: 10px; padding: 10px; font-size: 0.75em"
  >
    {{ 'key_noData' | translate }}
  </div>
  <ng-template #iterableFields>
    <button
      *ngIf="
        (config.isSimpleValue || !disabled(resource.rightSets)) &&
        config.editable
      "
      mat-stroked-button
      color="primary"
      class="add-button"
      [disabled]="config.maxCount && iterableValue.length >= config.maxCount"
      [matTooltip]="'key_add' | translate"
      (click)="onAddValue()"
    >
      {{ config.buttonText | translate }}
    </button>
    <div *ngIf="iterableValue" style="margin-top: 5px">
      <form autocomplete="off" #iterablesForm="ngForm">
        <div
          [dragula]="
            config.iterableType === 'array' ? 'ITERABLESCOLUMNS' : null
          "
          [(dragulaModel)]="iterableValue"
        >
          <div
            *ngFor="let itValue of iterableValue; let i = index"
            class="background-bg-color"
            style="margin-bottom: 15px"
          >
            <div
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="10px grid"
              style="padding: 5px; font-size: 0.75em"
            >
              <div
                *ngIf="config.iterableType === 'array'"
                fxFlex="none"
                class="ithandle disabled-text-color"
                style="cursor: pointer"
              >
                <mat-icon style="line-height: 34px">menu</mat-icon>
              </div>
              <div
                fxFlex="auto"
                fxLayout="row wrap"
                fxLayoutGap="10px grid"
                fxLayoutAlign="start start"
              >
                <div
                  *ngFor="let property of config.properties"
                  [fxFlex]="property.width ?? 0"
                  [ngStyle]="{
                    'margin-top.px':
                      property.type === 'textarea' || property.validationKey
                        ? 1.5
                        : 0,
                    display: property.isHidden ? 'none' : 'block'
                  }"
                >
                  <div [ngSwitch]="property.type">
                    <div *ngSwitchCase="'text'" style="width: 100%">
                      <app-editor-text
                        *ngIf="property.validationKey; else noValidationKey"
                        [name]="property.name + i"
                        [(ngModel)]="itValue[property.name]"
                        [config]="{
                          isSimpleValue: true,
                          isCode: true,
                          hintLimit: config.hintLimit,
                          customDisplayName: property.displayName,
                          customDescription: property.description,
                          required: property.isKey || property.required,
                          readOnly:
                            !config.isSimpleValue &&
                            disabled(resource.rightSets),
                          validationKey: property.validationKey,
                          updateOn: modelUpdateOn
                        }"
                        appExpressionValidator
                        (valueChange)="onValueChange(i, property.name)"
                      ></app-editor-text>
                      <ng-template #noValidationKey>
                        <mat-form-field style="width: 100%">
                          <mat-label>{{
                            property.displayName | translate
                          }}</mat-label>
                          <input
                            matInput
                            #textInput
                            autocomplete="off"
                            [name]="property.name + i"
                            [matTooltip]="property.description"
                            [(ngModel)]="itValue[property.name]"
                            [pattern]="property.validation"
                            [disabled]="
                              !config.isSimpleValue &&
                              disabled(resource.rightSets)
                            "
                            (ngModelChange)="onValueChange(i, property.name)"
                            (keyup)="onKeyUp(textInput)"
                            [required]="property.required"
                            [ngModelOptions]="{ updateOn: modelUpdateOn }"
                          />
                          <div
                            *ngIf="textInput.alt === 'invalid'"
                            style="
                              position: absolute;
                              top: 26px;
                              font-size: 0.75em;
                            "
                            class="warn-color"
                          >
                            invalid format
                          </div>
                        </mat-form-field>
                      </ng-template>
                    </div>
                    <div *ngSwitchCase="'textarea'" style="width: 100%">
                      <app-editor-text
                        [name]="property.name + i"
                        [(ngModel)]="itValue[property.name]"
                        [config]="{
                          isSimpleValue: true,
                          isCode: true,
                          hintLimit: config.hintLimit,
                          customDisplayName: property.displayName,
                          required: property.isKey || property.required,
                          readOnly:
                            !config.isSimpleValue &&
                            disabled(resource.rightSets),
                          validationKey: property.validationKey,
                          updateOn: modelUpdateOn
                        }"
                        appExpressionValidator
                        (valueChange)="onValueChange(i, property.name)"
                      ></app-editor-text>
                    </div>
                    <mat-form-field *ngSwitchCase="'multi'" style="width: 100%">
                      <mat-label>{{
                        property.displayName | translate
                      }}</mat-label>
                      <input
                        matInput
                        #textInput
                        autocomplete="off"
                        [name]="property.name + i"
                        [matTooltip]="property.description | translate"
                        [(ngModel)]="itValue[property.name]"
                        [pattern]="property.validation"
                        [disabled]="
                          !config.isSimpleValue && disabled(resource.rightSets)
                        "
                        (ngModelChange)="onValueChange(i, property.name)"
                        (keyup)="onKeyUp(textInput)"
                        [required]="property.required"
                        [ngModelOptions]="{ updateOn: modelUpdateOn }"
                      />
                      <div
                        *ngIf="textInput.alt === 'invalid'"
                        style="position: absolute; top: 26px; font-size: 0.75em"
                        class="warn-color"
                      >
                        invalid format
                      </div>
                    </mat-form-field>
                    <mat-form-field
                      *ngSwitchCase="'select'"
                      style="width: 100%"
                    >
                      <mat-label>{{
                        property.displayName | translate
                      }}</mat-label>
                      <mat-select
                        [name]="property.name + i"
                        [(ngModel)]="itValue[property.name]"
                        [matTooltip]="property.description | translate"
                        [disabled]="
                          !config.isSimpleValue && disabled(resource.rightSets)
                        "
                        (selectionChange)="onValueChange(i, property.name)"
                      >
                        <mat-option
                          *ngFor="let option of property.options"
                          [value]="option.value"
                        >
                          {{ option.text | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-checkbox
                      *ngSwitchCase="'boolean'"
                      style="width: 100%; margin-top: 12px"
                      [name]="property.name + i"
                      [matTooltip]="property.description | translate"
                      [disabled]="
                        !config.isSimpleValue && disabled(resource.rightSets)
                      "
                      [(ngModel)]="itValue[property.name]"
                      (change)="onValueChange(i, property.name)"
                      >{{ property.displayName | translate }}</mat-checkbox
                    >
                  </div>
                </div>
              </div>
              <span
                *ngIf="
                  config.isSimpleValue ||
                  (!configMode &&
                    !disabled(resource.rightSets) &&
                    config.editable)
                "
                fxFlex="none"
                class="material-icons warn-color"
                style="cursor: pointer; font-size: 20px"
                [matTooltip]="'key_remove' | translate"
                (click)="onRemoveValue(i)"
                >delete_outline</span
              >
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>
</div>
